<template>
    <div class="container">
        <div class="contentContainer">
            <p class="p1">首次测试请先完善个人信息</p>
            <p class="p2">请选择</p>
            <div id="selectContainer">
                <div class="gp_sex">
                    <div class="gp_b" @click=onSelectSex>
                        <img :src="imgLeft" alt="">
                        <p :style="`color:${colorLeft}`">男生</p>
                    </div>
                    <div class="gp_g" @click=onSelectSex>
                        <img :src="imgRight" alt="">
                        <p :style="`color:${colorRight}`">女生</p>
                    </div>
                </div>
                <div>
                    <van-field
                        readonly
                        clickable
                        name="picker"
                        :value="info.userAge"
                        label="年龄"
                        placeholder="点击选择年龄"
                        @click="ageAbout.ageShowPicker = true"
                    />
                    <van-popup v-model="ageAbout.ageShowPicker" position="bottom">
                    <van-picker
                        show-toolbar
                        :columns="ageAbout.ageColumns"
                        @confirm="onAgeConfirm"
                        @cancel="ageAbout.ageShowPicker = false"
                    />
                    </van-popup>
                </div>
                <div>
                    <van-field
                        readonly
                        clickable
                        name="picker"
                        :value="info.profession"
                        label="职业"
                        placeholder="点击选择职业"
                        @click="professionAbout.professionShowPicker = true"
                    />
                    <van-popup v-model="professionAbout.professionShowPicker" position="bottom">
                    <van-picker
                        show-toolbar
                        :columns="professionAbout.professionColumns"
                        @confirm="onProfessionConfirm"
                        @cancel="professionAbout.professionShowPicker = false"
                    />
                    </van-popup>
                </div>
                <div>
                    <van-field
                        readonly
                        clickable
                        name="picker"
                        :value="onEyeAbout.onEye"
                        label="戴镜"
                        placeholder="点击选择戴镜"
                        @click="onEyeAbout.onEyeShowPicker = true"
                    />
                    <van-popup v-model="onEyeAbout.onEyeShowPicker" position="bottom">
                    <van-picker
                        show-toolbar
                        :columns="onEyeAbout.onEyeColumns"
                        @confirm="onEyeConfirm"
                        @cancel="onEyeAbout.onEyeShowPicker = false"
                    />
                    </van-popup>
                </div>
                <!-- <div>
                    <span>性别：</span>
                    <select v-model="info.sex">
                        <option :value =0>男</option>
                        <option :value =1>女</option>
                    </select>
                </div> -->
            </div>
        </div>
        <div v-show="!ageAbout.ageShowPicker&&!professionAbout.professionShowPicker&&!onEyeAbout.onEyeShowPicker" class="footer" @click=onSubmit>
            完成
        </div>
        <div id="imgContainer" v-if='isShow'>
            <img id="showImg" v-if='isShow' src="../../assets/common/tip.png" alt="">
            <p>加载中...</p>
        </div>
    </div>
</template>

<script>
    // import axios from 'axios'
    export default {
        name:'PersonalInformation',
        inject:['reload'],
        data(){
            return{
                isShow:false,
                imgLeft:'',
                imgRight:'',
                colorLeft:'',
                colorRight:'',
                info:{
                    //0是男，1是女
                    sex:0,
                    userAge:'',
                    profession:'',
                    //1是戴镜，2是不戴
                    onEye:''
                },
                ageAbout:{
                    ageColumns: [1,2,3,4,5,6,7,8,9,10,11,12,13,14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99],
                    ageShowPicker: false,
                },
                professionAbout:{
                    professionColumns: ['学生','老师','校长','其他'],
                    professionShowPicker: false,
                },
                onEyeAbout:{
                    onEyeColumns: ['是','否'],
                    onEyeShowPicker: false,
                    onEye:''
                }
            }
        },
        methods:{
            onSelectSex(){
                if(this.info.sex===0){
                    this.info.sex=1
                    this.colorLeft='#999999'
                    this.colorRight='#297BFF'
                    this.imgLeft=require('../../assets/personalInformation/b_select.png')
                    this.imgRight=require('../../assets/personalInformation/g_selected.png')
                }
                else{
                    this.info.sex=0
                    this.colorLeft='#297BFF'
                    this.colorRight='#999999'
                    this.imgLeft=require('../../assets/personalInformation/b_selected.png')
                    this.imgRight=require('../../assets/personalInformation/g_select.png')
                }
            },
            onAgeConfirm(value) {
                this.info.userAge = value;
                this.ageAbout.ageShowPicker = false;
            },
            onProfessionConfirm(value) {
                this.info.profession = value;
                this.professionAbout.professionShowPicker = false;
            },
            onEyeConfirm(value) {
                if(value==='是'){
                    this.info.onEye=1
                }
                else{
                    this.info.onEye=2
                }
                this.onEyeAbout.onEye = value;
                this.onEyeAbout.onEyeShowPicker = false;
            },
            async onSubmit(){
                if(this.$store.state.global.isLoadingShow){
                    return
                }

                if(this.info.userAge===''){
                    this.$dialog.alert({
                        message:'请选择您的年龄!',
                    })
                    return
                }
                if(this.info.profession===''){
                    this.$dialog.alert({
                        message:'请选择您的职业!',
                    })
                    return
                }
                if(this.info.onEye===''){
                    this.$dialog.alert({
                        message:'请选择您是否戴镜!',
                    })
                    return
                }

                this.$store.state.global.isLoadingShow=true
                //提交信息
                await new Promise((resolve,reject)=>{
                    this.$store.state.global.onEye=this.info.onEye
                    this.$store.state.global.personalInformationBol=true
                    this.$axios({
                        url:this.$store.state.global.url+'/v5/yc-user-info/save',
                        method:'post',
                        data:this.info,
                        headers:{
                            'Authorization':'Bearer '+this.$store.state.global.token,
                            'serverFlag':'',
                            'dsName':'',
                            'content-type': 'application/json'
                        }
                    }).then(
                        response=>{
                            this.$store.state.global.isLoadingShow=false
                            //跳转页面
                            if(this.$store.state.global.isSkip){
                                // this.$router.push('/commonDescription')
                                this.isShow=true
                                setTimeout(() => {
                                    this.isShow=false
                                    this.$router.push('/commonDescription')
                                }, 8000);
                            }
                            else{
                                this.$router.push('/questionnaire')
                            }
                        },
                        error=>{
                            this.$store.state.global.isLoadingShow=false
                            this.$dialog.alert({
                                message:'信息提交失败，请稍后重试！',
                            }).then(()=>{
                                this.reload()
                            })
                        }
                    )
                });
            },
        },
        mounted(){
            this.$store.state.global.isTrans=false
            this.colorLeft='#297BFF'
            this.colorRight='#999999'
            this.imgLeft=require('../../assets/personalInformation/b_selected.png')
            this.imgRight=require('../../assets/personalInformation/g_select.png')
            // for(let i=1;i++;i<100){
            //     this.ageAbout.ageColumns.push(i)
            // }
        }
    }
</script>

<style scoped>
    #imgContainer p{
        position: absolute;
        left:50%;
        top:95%;
        transform:translate(-50%,0%);
        font-size: 3vw;
    }
    #imgContainer{
        width: 100%;
        height: 100%;
        background: rgb(255, 255, 255);
        position: relative;
    }
    #showImg{
        position: absolute;
        left:50%;
        top:50%;
        transform:translate(-50%,-50%);
        width: 100%;
    }
    .container{
        background: rgb(237, 241, 248);
    }
    .contentContainer{
        position: absolute;
        top: 10%;
        left: 3vw;
        width: 94vw;
        height: 90%;
        background: white;
        border-radius: 3vw;
    }
    .p1{
        font-size: 6vw;
        padding-top: 10vw;
        text-align: center;
        font-weight: bold;
    }
    .p2{
        font-size: 4vw;
        padding-top: 10vw;
        text-align: center;
    }
    #selectContainer{
        display: flex;
        flex-direction: column;
        position: absolute;
        left:50%;
        top:50%;
        transform:translate(-50%,-50%);
    }
    #selectContainer div{
        width: 80vw;
        padding-top: 5vw;
    }
    span{
        width: 10vw;
        font-size: 3vw;
        line-height: 6vw;
    }
    select{
        width: 80vw;
        height: 6vw;
        border-radius: 2vw;
    }
    .footer{
        position: absolute;
        left:50%;
        top:85%;
        transform:translate(-50%,0%);

        width: 80vw;
        height: 11vw;
        border-radius: 5vw;
        text-align: center;
        line-height: 11vw;
        font-size: 4vw;
        background: rgb(41, 123, 255);
        color: white;
    }
    .gp_sex div{
        width: 40vw;
    }
    .gp_sex img{
        width: 20vw;
        margin-left: 10vw;
    }
    .gp_sex p{
        width: 40vw;
        color: rgb(153, 153, 153);
        font-size: 3vw;
        text-align: center;
        margin-top: 3vw;
    }
    .gp_sex{
        display: flex;
        flex-direction: row;
    }
</style>